import type { CommissionEditRequest } from "@/lib/commission.api";
import { cn } from "@/lib/utils";
import { STATUS_CLASSES, STATUS_LABELS } from "../commissionEditQueue.constants";

export function CommissionEditStatusBadge({
  status,
}: {
  status: CommissionEditRequest["status"];
}) {
  return (
    <span
      className={cn(
        "inline-flex rounded border px-2 py-0.5 text-[10.5px] font-semibold",
        STATUS_CLASSES[status],
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
